import * as React from 'react';

export type PayrollTabKey = 'periods' | 'workEvidence' | 'changes' | 'run';

/** Lets components rendered inside the Payroll page switch its tab without a route change. */
export interface PayrollTabContextValue {
    readonly selectTab: (tab: PayrollTabKey) => void;
}

export const PayrollTabContext = React.createContext<PayrollTabContextValue | null>(null);

export const usePayrollTabSelector = (): PayrollTabContextValue | null => React.useContext(PayrollTabContext);
